<a class="db-datepicker-select" [ngClass]="{'ds-dropdown-toggled': toggled}"
   [ngStyle]="{width: dsDatePickerWidth, height: dsDatePickerHeight}"
   dbDatepicker #dp="dbDatepicker" (click)="dp.toggle(); toggled = true"
   [autoClose]="autoClose" [displayMonths]="displayMonths" [firstDayOfWeek]="firstDayOfWeek" [markDisabled]="markDisabled"
   [minDate]="minDate" [maxDate]="maxDate" [outsideDays]="outsideDays" [startDate]="startDate" [endDate]="endDate"
   [placement]="placement" [canSelectRange]="canSelectRange" [selectOnClick]="selectOnClick"
   (dateSelect)="onDateSelect($event)" (dateClear)="onDateClear()" (navigate)="navigate.emit($event)"
   (closed)="close()" [disabled]="disabled">
  <i class="db-icon db-icon-ds-calendar calendar"></i>
  <span [innerHTML]="datePlaceHolder">
  </span>
  <i class="db-icon db-icon-ds-arrow-small"></i>
</a>
